import TokenService from "./token.service";

const ApiService = {

    init(baseURL) {
        axios.defaults.baseURL = baseURL;
    },

    setHeader(key, value) {
        axios.defaults.headers.common[key] = value;
    },

    setDefaultHeaders() {
        this.setHeader("X-Requested-With", "XMLHttpRequest");
        this.setHeader("X-CSRF-TOKEN", CSRFtoken);
    },

    setAuthHeader() {
        this.setHeader("Authorization", `Bearer ${TokenService.getToken()}`);
    },

    setHeaders(headers) {
        this.setDefaultHeaders();
        for (let header in headers) {
            axios.defaults.headers.common[header] = headers[header];
        }
    },

    removeHeader(key) {
        delete axios.defaults.headers.common[key];
    },

    removeAuthHeader() {
        this.removeHeader("Authorization");
    },

    clearHeaders() {
        axios.defaults.headers.common = {}
    },

    get(resource, params = null) {
        return axios.get(resource, {
            params: params
        })
    },

    post(resource, data, config = {}) {
        return axios.post(resource, data, config)
    },

    put(resource, data) {
        return axios.put(resource, data)
    },

    delete(resource) {
        return axios.delete(resource)
    },

    /**
     * Perform a custom axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
     **/
    customRequest(data) {
        return axios(data)
    }
}

export default ApiService
